export default function IconPictureLandscape({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="Picture-Landscape Streamline Ultimate" clipPath="url(#clip0_0_54)">
        <path
          id="Vector"
          d="M17.2651 1.45337V12.9534H0.733887V1.45337C0.733887 1.26274 0.809612 1.07993 0.944404 0.945136C1.0792 0.810344 1.26201 0.734619 1.45264 0.734619H16.5464C16.737 0.734619 16.9198 0.810344 17.0546 0.945136C17.1894 1.07993 17.2651 1.26274 17.2651 1.45337Z"
          fill="#93C5FD"
        />
        <path
          id="Vector_2"
          d="M17.0991 1.01206C17.034 0.92693 16.9505 0.857716 16.8547 0.80965C16.759 0.761585 16.6535 0.735928 16.5464 0.734619H1.45264C1.26201 0.734619 1.0792 0.810344 0.944404 0.945136C0.809612 1.07993 0.733887 1.26274 0.733887 1.45337V12.9534H5.15707L17.0991 1.01206Z"
          fill="#EFF6FF"
        />
        <path
          id="Vector_3"
          d="M17.2651 1.45337V12.9534H0.733887V1.45337C0.733887 1.26274 0.809612 1.07993 0.944404 0.945136C1.0792 0.810344 1.26201 0.734619 1.45264 0.734619H16.5464C16.737 0.734619 16.9198 0.810344 17.0546 0.945136C17.1894 1.07993 17.2651 1.26274 17.2651 1.45337Z"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M2.89014 12.9529C2.89014 12.9529 4.32764 9.3591 6.12451 9.3591C7.92139 9.3591 9.35889 11.5154 9.35889 11.5154L11.5259 7.80085C11.6357 7.61344 11.7941 7.45918 11.9844 7.35439C12.1746 7.2496 12.3897 7.19816 12.6068 7.20553C12.8239 7.21289 13.0349 7.27878 13.2176 7.39622C13.4004 7.51367 13.5479 7.6783 13.6448 7.87273L16.187 12.9529"
          fill="#93C5FD"
        />
        <path
          id="Vector_5"
          d="M17.2651 12.9529V16.5466C17.2651 16.7373 17.1894 16.9201 17.0546 17.0549C16.9198 17.1897 16.737 17.2654 16.5464 17.2654H1.45264C1.26201 17.2654 1.0792 17.1897 0.944404 17.0549C0.809612 16.9201 0.733887 16.7373 0.733887 16.5466V12.9529H17.2651Z"
          fill="white"
        />
        <path
          id="Vector_6"
          d="M7.20303 2.89087C6.77727 2.8922 6.36581 3.04466 6.04199 3.3211C5.71817 3.59753 5.50303 3.97997 5.43491 4.40024C5.28724 4.34344 5.12889 4.31984 4.97108 4.33111C4.81327 4.34237 4.65987 4.38823 4.52177 4.46543C4.38368 4.54263 4.26426 4.64928 4.172 4.77781C4.07975 4.90634 4.01691 5.05359 3.98795 5.20913C3.95898 5.36467 3.96461 5.52468 4.00442 5.6778C4.04423 5.83092 4.11726 5.9734 4.21831 6.09513C4.31937 6.21686 4.44598 6.31486 4.58916 6.38217C4.73233 6.44949 4.88857 6.48446 5.04678 6.48462H7.20303C7.6796 6.48462 8.13664 6.29531 8.47362 5.95833C8.8106 5.62135 8.99991 5.16431 8.99991 4.68774C8.99991 4.21118 8.8106 3.75414 8.47362 3.41716C8.13664 3.08018 7.6796 2.89087 7.20303 2.89087Z"
          fill="white"
        />
        <path
          id="Vector_7"
          d="M2.89014 12.9529C2.89014 12.9529 4.32764 9.3591 6.12451 9.3591C7.92139 9.3591 9.35889 11.5154 9.35889 11.5154L11.5259 7.80085C11.6357 7.61344 11.7941 7.45918 11.9844 7.35439C12.1746 7.2496 12.3897 7.19816 12.6068 7.20553C12.8239 7.21289 13.0349 7.27878 13.2176 7.39622C13.4004 7.51367 13.5479 7.6783 13.6448 7.87273L16.187 12.9529"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M17.2651 12.9529V16.5466C17.2651 16.7373 17.1894 16.9201 17.0546 17.0549C16.9198 17.1897 16.737 17.2654 16.5464 17.2654H1.45264C1.26201 17.2654 1.0792 17.1897 0.944404 17.0549C0.809612 16.9201 0.733887 16.7373 0.733887 16.5466V12.9529H17.2651Z"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_9"
          d="M7.20303 2.89087C6.77727 2.8922 6.36581 3.04466 6.04199 3.3211C5.71817 3.59753 5.50303 3.97997 5.43491 4.40024C5.28724 4.34344 5.12889 4.31984 4.97108 4.33111C4.81327 4.34237 4.65987 4.38823 4.52177 4.46543C4.38368 4.54263 4.26426 4.64928 4.172 4.77781C4.07975 4.90634 4.01691 5.05359 3.98795 5.20913C3.95898 5.36467 3.96461 5.52468 4.00442 5.6778C4.04423 5.83092 4.11726 5.9734 4.21831 6.09513C4.31937 6.21686 4.44598 6.31486 4.58916 6.38217C4.73233 6.44949 4.88857 6.48446 5.04678 6.48462H7.20303C7.6796 6.48462 8.13664 6.29531 8.47362 5.95833C8.8106 5.62135 8.99991 5.16431 8.99991 4.68774C8.99991 4.21118 8.8106 3.75414 8.47362 3.41716C8.13664 3.08018 7.6796 2.89087 7.20303 2.89087Z"
          stroke="#1D4ED8"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_54">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
